module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/8c07dca0e3f9f9c84b2fd70f4f1fbff9.png";